import {CountUp} from 'countup.js';
require('waypoints/lib/noframework.waypoints.js')

$(function () {
    const els = document.getElementsByClassName('data-counter');

    for (let el of els) {
        let endValue = el.dataset.counter;
        let suffix = el.dataset.suffix;

        new Waypoint({
            element: el,
            handler: function () {
                const options = {
                    duration: 3,
                    useEasing: true,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    suffix: suffix
                };
                let countUp = new CountUp(el, endValue, options);

                countUp.start();
                this.destroy();
            },
            offset: 'bottom-in-view',
        })
    }
})